import { render, staticRenderFns } from "./svgYoutube.vue?vue&type=template&id=721e5594&scoped=true"
import script from "./svgYoutube.vue?vue&type=script&lang=js"
export * from "./svgYoutube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721e5594",
  null
  
)

export default component.exports